import BsCarousel from 'react-bootstrap/lib/Carousel'
import Icon, {icons} from './icon'
import PropTypes from 'prop-types'
import React, {Component} from 'react'
import Swipeable from './swipeable'
import {colors} from '../styles'
import {css} from 'glamor'
import {forceCheck} from 'react-lazyload'

const style = {
  carousel: ({controls, indicators}) =>
    css({
      display: 'flex',
      alignItems: 'center',
      '& > .carousel-inner': {
        display: 'inline-block',
        width: controls !== false ? '90%' : '100%',
        order: 1
      },
      '& > .carousel-control': {
        backgroundImage: 'none',
        position: 'relative',
        display: 'inline-block',
        width: '5%',
        top: 'unset',
        left: 'unset',
        right: 'unset',
        bottom: 'unset',
        '&.left': {
          order: 0,
          left: 'unset'
        },
        '&.right': {
          order: 2,
          right: 'unset'
        }
      },
      paddingBottom: indicators !== false ? '30px' : null,
      '& > .carousel-indicators': {
        bottom: 0,
        left: 0,
        width: '100%',
        margin: 0,
        '& > li': {
          border: 'none',
          backgroundColor: colors.gray77,
          '&.active': {
            backgroundColor: colors.primaryBG,
            height: '10px',
            margin: '1px',
            width: '10px'
          }
        }
      }
    }),
  icon: css({
    color: colors.black,
    fontSize: '20px'
  })
}

class Carousel extends Component {
  constructor(props) {
    super(props)
    this.state = {activeIndex: props.defaultActiveIndex}
  }

  onSwipe = (e, swipe) => {
    if (!(swipe.left || swipe.right)) {
      return
    }

    e.preventDefault()
    const {children} = this.props

    let activeIndex = this.state.activeIndex + (swipe.left ? -1 : 1)
    if (activeIndex < 0) {
      activeIndex = 0
    } else if (activeIndex >= children.length) {
      activeIndex = children.length - 1
    }

    this.setState({activeIndex})
  }

  onSelect = (activeIndex) => {
    this.setState({activeIndex})
  }

  render() {
    const {
      children,
      defaultActiveIndex, // eslint-disable-line no-unused-vars
      iconKind,
      iconTop,
      swipe,
      ...props
    } = this.props

    return (
      <Swipeable onSwipe={swipe ? this.onSwipe : null}>
        <BsCarousel
          onSlideEnd={() => forceCheck()}
          activeIndex={this.state.activeIndex}
          onSelect={this.onSelect}
          interval={null}
          prevIcon={
            iconKind ? (
              <Icon icon={icons[`${iconKind}Left`]} {...style.icon} />
            ) : null
          }
          nextIcon={
            iconKind ? (
              <Icon icon={icons[`${iconKind}Right`]} {...style.icon} />
            ) : null
          }
          wrap={false}
          {...props}
          {...style.carousel({...props, iconTop})}
        >
          {children}
        </BsCarousel>
      </Swipeable>
    )
  }
}

Carousel.propTypes = {
  children: PropTypes.any,
  defaultActiveIndex: PropTypes.number,
  iconKind: PropTypes.oneOf(['angle', 'chevron']),
  iconTop: PropTypes.string,
  swipe: PropTypes.bool
}

Carousel.defaultProps = {
  defaultActiveIndex: 0,
  iconKind: 'angle',
  iconTop: '15%',
  swipe: true
}

Carousel.Item = BsCarousel.Item

export default Carousel
